/**
 * Live Retell transcript. retell-webhook broadcasts every transcript_updated
 * snapshot on the private topic `retell-transcript:<user_id>:<call_id>`, where
 * user_id is the signed webhook's call.metadata.user_id; the realtime.messages
 * policy only admits topics prefixed with the subscriber's own auth.uid().
 * Returns an unsubscribe function that is safe to call at any time.
 */
export const subscribeRetellTranscript = (supabase, callId, onTurns) => {
  let channel = null;
  let closed = false;

  (async () => {
    await supabase.realtime.setAuth();
    if (closed) return;
    const { data: { session } } = await supabase.auth.getSession();
    const userId = session?.user?.id;
    if (!userId || closed) {
      if (!userId) console.warn('[retellTranscript] no session');
      return;
    }
    channel = supabase
      .channel(`retell-transcript:${userId}:${callId}`, { config: { private: true } })
      // Event name must match TRANSCRIPT_EVENT in supabase/functions/_shared/retellWebhook.ts.
      .on('broadcast', { event: 'transcript' }, ({ payload }) => {
        if (Array.isArray(payload?.turns)) onTurns(payload.turns);
      })
      .subscribe((status, err) => {
        if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') {
          console.warn('[retellTranscript] channel', status, err?.message ?? '');
        }
      });
  })().catch((e) => console.warn('[retellTranscript] subscribe failed', e));

  return () => {
    closed = true;
    if (channel) supabase.removeChannel(channel);
    channel = null;
  };
};
